import React from "react";
import PhoneNav from "../PhoneNav";
import Frame148 from "../Frame148";
import FAQ1False from "../FAQ1False";
import FAQ2False from "../FAQ2False";
import FAA3False from "../FAA3False";
import FAQ4False from "../FAQ4False";
import Frame304 from "../Frame304";
import "./ContactUs.css";

function ContactUs(props) {
  const {
    contactUs,
    welcomeToTheConta,
    findOutEverything,
    bookAnAppointment,
    callUs,
    phone1,
    monFri8Am8Pm1,
    emailUs,
    junejasohniGmailCom,
    text1,
    whatsapp,
    phone2,
    monFri8Am8Pm2,
    bookAppointment,
    phone3,
    monFri8Am8Pm3,
    address,
    r2552NdFloor,
    x123LaneOppSai,
    phoneNavProps,
    frame148Props,
    fAQ1FalseProps,
    fAQ2FalseProps,
    fAA3FalseProps,
    fAQ4FalseProps,
    frame304Props,
  } = props;

  return (
    <div className="contact-us-4 screen">
      <PhoneNav image22={phoneNavProps.image22} className={phoneNavProps.className} />
      <div className="frame-137-1">
        <div className="contact-us-5 poppins-medium-tundora-18px">{contactUs}</div>
      </div>
      <div className="frame-294">
        <div className="frame-137-2 poppins-normal-tundora-14px">
          <p className="welcome-to-the-conta">{welcomeToTheConta}</p>
          <p className="find-out-everything">{findOutEverything}</p>
          <p className="book-an-appointment">{bookAnAppointment}</p>
        </div>
      </div>
      <div className="frame-296">
        <div className="frame-295">
          <div className="group-137">
            <div className="call-us poppins-medium-tundora-18px">{callUs}</div>
          </div>
          <div className="phone-3 valign-text-bottom roboto-normal-tundora-15px">{phone1}</div>
          <p className="mon-fri-8am-8pm valign-text-bottom roboto-normal-tundora-15px">{monFri8Am8Pm1}</p>
          <div className="group-138-8">
            <div className="email-us poppins-medium-tundora-18px">{emailUs}</div>
          </div>
          <a href="mailto:junejasohni@gmail.com" target="_blank">
            <div className="junejasohnigmailcom valign-text-bottom roboto-normal-tundora-15px">
              {junejasohniGmailCom}
            </div>
          </a>
          <div className="text-1 valign-text-bottom roboto-normal-tundora-15px">{text1}</div>
          <div className="group-139">
            <div className="whatsapp poppins-medium-tundora-18px">{whatsapp}</div>
          </div>
          <div className="phone-3 valign-text-bottom roboto-normal-tundora-15px">{phone2}</div>
          <p className="mon-fri-8am-8pm valign-text-bottom roboto-normal-tundora-15px">{monFri8Am8Pm2}</p>
          <div className="group-140">
            <div className="book-appointment poppins-medium-tundora-18px">{bookAppointment}</div>
          </div>
          <div className="phone-3 valign-text-bottom roboto-normal-tundora-15px">{phone3}</div>
          <p className="mon-fri-8am-8pm valign-text-bottom roboto-normal-tundora-15px">{monFri8Am8Pm3}</p>
          <div className="group-141">
            <div className="address poppins-medium-tundora-18px">{address}</div>
          </div>
          <p className="r-255-2nd-floor-3 valign-text-bottom roboto-normal-tundora-14px">{r2552NdFloor}</p>
          <p className="x123-lane-opp-sai-3 valign-text-bottom roboto-normal-tundora-14px">{x123LaneOppSai}</p>
        </div>
      </div>
      <Frame148 className={frame148Props.className} />
      <div className="frame-29">
        <FAQ1False className={fAQ1FalseProps.className} frame43Props={fAQ1FalseProps.frame43Props} />
      </div>
      <div className="frame-29">
        <FAQ2False className={fAQ2FalseProps.className} frame432Props={fAQ2FalseProps.frame432Props} />
      </div>
      <div className="frame-299">
        <FAA3False className={fAA3FalseProps.className} frame433Props={fAA3FalseProps.frame433Props} />
      </div>
      <div className="frame-300">
        <FAQ4False className={fAQ4FalseProps.className} frame434Props={fAQ4FalseProps.frame434Props} />
      </div>
      <div className="frame-304-1">
        <Frame304 className={frame304Props.className} frame302Props={frame304Props.frame302Props} />
      </div>
    </div>
  );
}

export default ContactUs;
